import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/axios';

export interface Product {
  _id: string;
  name: string;
  sellingPrice?: number;
  hsnSac?: string;
  cgstRate?: number;
  sgstRate?: number;
  igstRate?: number;
  description?: string;
  unit?: string;
}

export function useProducts() {
  return useQuery({
    queryKey: ['products'],
    queryFn: async () => {
      const { data } = await api.get<{ data: Product[] }>('/master-data/products-services?limit=100&isActive=true');
      return data.data ?? [];
    },
  });
}

export function useCatalogApi() {
  return {
    useProducts,
  };
}